import React, { useContext } from 'react';
import Modal from '../../../../../../../components/Modal/Modal';
import { deletDiscount } from '../DiscountsTab';
import userEvent from '@testing-library/user-event';
import { Access } from '../../../../PortalAccess/AccessEnum';
import { dashboardContext } from '../../../../../Dashboard';
import { DiscountType } from './CreateGroupDiscount';
import ConfirmationBox from '../../../../../../../components/ConfirmationBox/ConfirmationBox';

const DeleteFeeHead = ({ setDeleteFeeHead, id, set_get_discounts, getDiscounts }: any) => {
	async function handleDelete() {
		try {
			let res = await deletDiscount(id);
			if (res instanceof Error) {
				console.log('something went wrong!');
			} else {
				setDeleteFeeHead(false);
				set_get_discounts(await getDiscounts());
			}
		} catch (err) {
			console.log(err);
		}
	}
	return (
		<>
			<ConfirmationBox
				setOpen={setDeleteFeeHead}
				funtion={handleDelete}
				confirmationText='delete this discount'
				ButtonText='Delete'
			/>
		</>
	);
};

const EditDelete = ({ setToggle, setDeleteFeeHead }: any) => {
	return (
		<div className='absolute py-2  bottom-0 right-5 hover:bg-slate-200 px-4 w-36 rounded-lg shadow bg-[#F8FAFB]'>
			{/* <div
				onClick={() => {
					setEditFeeHead(true);
					setToggle(false);
				}}
				className='py-2 cursor-pointer'
			>
				Edit
			</div> */}
			{/* <hr /> */}
			<div
				onClick={() => {
					setDeleteFeeHead(true);
					setToggle(false);
				}}
				className='text-red-400 cursor-pointer'
			>
				Delete
			</div>
		</div>
	);
};
function GroupDiscountCard({ discount, set_get_discounts, getDiscounts, get_fee_heads }: any) {
	const [showModal, setShowModal] = React.useState(false);
	const [showFeeHeadModal, setShowFeeHeadModal] = React.useState(false);
	const [toggle, setToggle] = React.useState(false);
	const [isDeleteFeeHead, setDeleteFeeHead] = React.useState(false);
	const [showTagModal,setShowTagModal]=React.useState(false)
	const { user } = useContext(dashboardContext);
	//console.log(discount.tags)
	return (
		<div
			onMouseLeave={() => {
				if (toggle === true) {
					setToggle(false);
				}
			}}
		>
			<div className='fee-head-card h-full'>
				<Modal open={showModal} setOpen={setShowModal} title='Classes'>
					{
						<div className='mx-auto text-center'>
							{discount.group_class.map((class_name: any) => (
								<div key={class_name}>{class_name}</div>
							))}
						</div>
					}
				</Modal>
				<Modal open={showTagModal} setOpen={setShowTagModal} title='Tags'>
				<div className='mx-auto text-center'>
							{discount?.tags?.map((tag: any) => (
								<div  key={tag.tagCode}>{tag.tagCode}</div>
							))}
						</div>
				</Modal>
				<Modal open={showFeeHeadModal} setOpen={setShowFeeHeadModal} title='Fee Head' className='max-w-2xl w-full'>
					{get_fee_heads
						.filter((f: any) => f._id === discount?.fee_head)
						.map((fee_head: any) => {
							return (
								<div key={fee_head._id} className='p-5 shadow rounded-md h-full'>
									<div className='fee_head_header font-medium flex justify-between items-center'>
										<div> {fee_head.name}</div>
									</div>
									<div className='grid grid-cols-3 mt-4 gap-4'>
										<div className=''>
											<div className='text-sm font-light '>Fee</div>
											<div className='mt-2 text-sm font-medium'>
												{'₹' + (fee_head.amount as number).toLocaleString('hi')}
											</div>
										</div>
										<div className='border-l-2 px-4'>
											<div className='text-sm font-light '>Tax</div>
											<div className='mt-2 text-sm font-medium'>{fee_head.tax + '%'}</div>
										</div>
										<div className='border-l-2 px-4'>
											<div className='text-sm font-light '>Class</div>
											<div className='mt-2 text-sm font-medium '>{fee_head.class.join(',')}</div>
										</div>
										<div className=''>
											<div className='text-sm font-light '>Starting Date</div>
											<div className='mt-2 text-sm font-medium'>{new Date(fee_head.start_date).toDateString()}</div>
										</div>
										<div className=''>
											<div className='text-sm font-light '>Ending Date</div>
											<div className='mt-2 text-sm font-medium'>{new Date(fee_head.end_date).toDateString()}</div>
										</div>
										{/* <div className='border-l-2 px-4'>
											<div className='text-sm font-light '>Total Fee</div>
											<div className='mt-2 text-sm font-medium'>
												₹{((fee_head.amount * 12) / fee_head.frequency_months).toLocaleString('hi')}
											</div>
										</div> */}
									</div>
								</div>
							);
						})}
				</Modal>
				<Modal
					children={
						<DeleteFeeHead
							setDeleteFeeHead={setDeleteFeeHead}
							id={discount._id}
							set_get_discounts={set_get_discounts}
							getDiscounts={getDiscounts}
						/>
					}
					title='Delete'
					open={isDeleteFeeHead}
					setOpen={setDeleteFeeHead}
				/>
				<div className='p-5 shadow rounded-md h-full'>
					<div className='fee_head_header font-medium flex justify-between items-center'>
						<div>{discount.name}</div>
						<div className='relative'>
							{(user.access === Access.SUPER || user.access === Access.ALL_ACCESS) && (
								<i
									onClick={() => setToggle((prev) => !prev)}
									className='fa-solid fa-ellipsis-vertical ml-auto cursor-pointer p-2'
								></i>
							)}
							{toggle ? <EditDelete setDeleteFeeHead={setDeleteFeeHead} setToggle={setToggle} /> : ''}
						</div>
					</div>
					<div className='grid  grid-cols-2 mt-4 gap-4'>
						{/* <div className=''>
							<div className='text-sm font-light '>Type</div>
							<div className='mt-2 text-sm font-medium'>{discount.type}</div>
						</div> */}

						<div className=''>
							<div className='text-sm font-light '>Value</div>
							<div>
								{discount.discount_type === DiscountType.ABSOLUTE_ONE_TIME ? (
									`₹ ${discount.value.toLocaleString('hi')}`
								) : (
									<div>
										<span className={'text-black text-sm font-medium capitalize'}>{discount.value}% of</span>
										<span
											onClick={() => {
												if (discount?.discount_type === DiscountType.RECURRING_PERCENTAGE_OF_FEE_HEAD) {
													setShowFeeHeadModal(!showFeeHeadModal);
												}
											}}
											className={
												'ml-2 text-sm font-medium capitalize ' +
												(discount?.discount_type === DiscountType.RECURRING_PERCENTAGE_OF_FEE_HEAD
													? '  text-violet-600 cursor-pointer'
													: '')
											}
										>
											{discount?.discount_type === DiscountType.RECURRING_PERCENTAGE_OF_FEE_HEAD
												? get_fee_heads.filter((f: any) => f._id === discount?.fee_head)[0]?.name
												: discount?.discount_type === DiscountType.RECURRING_PERCENTAGE_OF_INSTALLMENT
												? 'Installment'
												: null}
										</span>
									</div>
								)}
							</div>
						</div>
						<div className='border-l-2 px-4'>
							<div className='text-sm font-light '>Class</div>
							<div
								className='mt-2 text-sm font-medium text-violet-600 cursor-pointer'
								onClick={() => {
									setShowModal(true);
								}}
							>
								{discount.group_class.length + ' Classes'}
							</div>
						</div>

					{discount['applicable_on']==='GROUP' &&
					<div className='pr-4'>
					<div className='text-sm font-light '>Categories</div>
					<div className={'mt-2 text-sm font-medium '}>
						{discount.group_category
							.map((e: any) => {
								if (e === 'general') return 'General';
								if (e === 'sc') return 'SC';
								if (e === 'st') return 'ST';
								if (e === 'obc') return 'OBC';
								else return e;
							})
							.join(', ')}
					</div>
				</div>}	
				{discount['applicable_on']==='TAG'&&
				<div>
				<div className='text-sm font-light '>Tags</div>
				<div className={'mt-2 text-sm font-medium flex gap-2 '}>
					
						  <span onClick={()=>setShowTagModal(!showTagModal)}
							     className="bg-[#6F6AF8] hover:cursor-pointer text-white text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-[#6F6AF8]-900 dark:text-white">
								 {discount?.tags?.length} {discount?.tags?.length>1?'Tags':'Tag'}
							</span>
							
				</div>
			</div>
				}
				
				<div className=' border-l-2 px-4'>
				<div className='text-sm font-light '>Gender</div>
				<div className='mt-2 text-sm font-medium capitalize'>{discount.group_gender.join(', ')}</div>
			</div>
 					
					</div>
				</div>
			</div>
		</div>
	);
}

export default GroupDiscountCard;
